import { ExtensionRequestDialogController } from './extension-request-dialog.controller';
import { ExtensionRequestDialogProps } from './extension-request-dialog.model';

export const ExtensionRequestDialog = (props: ExtensionRequestDialogProps) => {
  return <ExtensionRequestDialogController {...props} />;
};
